var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.8C12.9941 10.8 13.8 9.99411 13.8 9C13.8 8.00589 12.9941 7.2 12 7.2C11.0059 7.2 10.2 8.00589 10.2 9C10.2 9.99411 11.0059 10.8 12 10.8ZM9.46255 14.2C9.34727 14.3897 9.20727 14.6612 9.05683 15.0022C8.88312 15.3959 8.7124 15.8433 8.56255 16.3H15.4375C15.2876 15.8433 15.1169 15.3959 14.9432 15.0022C14.7927 14.6612 14.6527 14.3897 14.5374 14.2H13.9887C13.396 14.519 12.7179 14.7 12 14.7C11.2821 14.7 10.604 14.519 10.0113 14.2H9.46255ZM10.3411 13H9C8.59856 13 7.80425 14.6421 7.30458 16.3C7.1819 16.7071 7.07698 17.1151 7 17.5H17C16.923 17.1151 16.8181 16.7071 16.6954 16.3C16.1957 14.6421 15.4014 13 15 13H13.6589C13.1837 13.3159 12.6134 13.5 12 13.5C11.3866 13.5 10.8163 13.3159 10.3411 13ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.aea3a68e03ba67eddcaaaf3aa0152e80.svg";
export { ForwardRef as ReactComponent };